import React from 'react';
import { X } from 'lucide-react';

interface PillProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  onRemove?: () => void;
  className?: string;
}

const variantClasses = {
  default: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  primary: 'bg-blue-50 text-blue-700 hover:bg-blue-100',
  secondary: 'bg-purple-50 text-purple-700 hover:bg-purple-100',
  success: 'bg-green-50 text-green-700 hover:bg-green-100',
  warning: 'bg-amber-50 text-amber-700 hover:bg-amber-100',
  danger: 'bg-red-50 text-red-700 hover:bg-red-100',
};

export function Pill({ children, variant = 'primary', onRemove, className = '' }: PillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${variantClasses[variant]} ${className}`}
    >
      {children}
      {onRemove && (
        <button
          onClick={onRemove}
          className="hover:opacity-70 transition-opacity"
          aria-label="Remove"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </span>
  );
}

interface TimeframePillProps {
  days: number;
  className?: string;
}

export function TimeframePill({ days, className = '' }: TimeframePillProps) {
  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-50 text-purple-700 ${className}`}
    >
      {days} days
    </span>
  );
}
